import gql from 'graphql-tag';
import { customerFragment } from '../../actions/graphql';

const discountCodeFragment = gql`
  fragment discountCode on DiscountCode {
    id
    code
    discountAmount
    discountPercentage
    discountType
    serviceIds
  }
`;

export const GET_APPOINTMENT = gql`
  query getAppointment($id: Int!) {
    appointment(id: $id) {
      id
      startAt
      serviceNames
      customer {
        ...customer
      }
      discountCode {
        ...discountCode
      }
      parts {
        id
        resourceId
        service {
          id
          medical
          name
          price
        }
        servicePackageService {
          id
          price
          originalPrice
        }
      }
      paidThroughTreatwell
      pricePaidThroughTreatwell
      priceAfterDiscount
      discountAmount
      discountPercentage
      locationId
    }
  }
  ${customerFragment}
  ${discountCodeFragment}
`;

export const orderItemFragment = gql`
  fragment orderItem on OrderItem {
    id
    price
    quantity
    medical
    serviceId
    productId
    description
    loyaltyPointsAmount
    medicalReferenceNumber
    giftcard {
      id
      code
    }
    soldPrepaidCard {
      id
      description
      quantity
    }
    originalPrice
    appointmentPart {
      id
      appointmentId
    }
    discountCode {
      ...discountCode
    }
    employeeId
    transactionCost
    usedPrepaidCardId
    vatPercentage
    treatmentDate
    servicePackageService {
      id
    }
  }
  ${discountCodeFragment}
`;

export const transactionFragment = gql`
  fragment transaction on Transaction {
    id
    type
    amount
    description
    giftcard {
      id
      code
    }
    prepaidCard {
      id
      description
      remaining
      price
      quantity
      pricePerUse
      status
    }
    cashupId
    deletable
    locationId
    transactionAt
  }
`;

export const GET_ORDER = gql`
  query getOrder($id: ID!) {
    order(id: $id) {
      id
      invoicedAt
      pending
      comments
      cashupId
      draft
      fiscalizationFinished
      documents {
        documentType
      }
      customer {
        ...customer
      }
      items {
        ...orderItem
      }
      appointments {
        id
        startAt
        serviceIds
        serviceNames
        customer {
          ...customer
        }
        parts {
          id
        }
        discountCode {
          ...discountCode
        }
        paidThroughTreatwell
        pricePaidThroughTreatwell
        priceAfterDiscount
      }
      locationId
      transactions {
        ...transaction
      }
      permissions {
        editOrderItems
      }
      orderDiscount {
        discountAmount
        discountPercentage
        discountType
      }
      state
    }
  }
  ${customerFragment}
  ${discountCodeFragment}
  ${orderItemFragment}
  ${transactionFragment}
`;

export const GET_CUSTOMER = gql`
  query getCustomer($id: Int!) {
    customer(id: $id) {
      ...customer
    }
  }
  ${customerFragment}
`;

export const orderCustomerFragment = gql`
  fragment orderCustomer on Customer {
    id
    firstName
    fullName
    mobilePhone
    phone
    email
    loyaltyPoints
    totalDue
    address
  }
`;

export const CREATE_ORDER = gql`
  mutation createOrder($input: CreateOrderInput!, $withCustomer: Boolean!) {
    createOrder(input: $input) {
      order {
        id
        fiscalizationFinished
        invoicedAt
        customer @include(if: $withCustomer) {
          ...orderCustomer
        }
        number
        state
      }
      errors
    }
  }
  ${orderCustomerFragment}
`;

export const UPDATE_ORDER = gql`
  mutation updateOrder($input: UpdateOrderInput!, $withCustomer: Boolean!) {
    updateOrder(input: $input) {
      order {
        id
        fiscalizationFinished
        invoicedAt
        customer @include(if: $withCustomer) {
          ...orderCustomer
        }
        number
        state
      }
      errors
    }
  }
  ${orderCustomerFragment}
`;
